var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('transition', {
    attrs: {
      "name": "fast-fade"
    }
  }, [_vm.source ? _c('div', {
    staticClass: "background"
  }, [_c('transition', {
    attrs: {
      "name": "fade-in",
      "mode": "in-out"
    }
  }, [_c('div', {
    key: _vm.activeSource + _vm.sourceType,
    staticClass: "background__wrapper"
  }, [_vm.sourceType === 'image' ? _c('img', {
    attrs: {
      "src": _vm.activeSource
    }
  }) : _vm._e(), _vm.sourceType === 'iframe' ? _c('iframe', {
    staticClass: "background__iframe",
    style: _vm.iframeStyle,
    attrs: {
      "src": _vm.activeSource,
      "frameborder": "0",
      "allowfullscreen": ""
    },
    on: {
      "load": _vm.handleIframeLoad,
      "error": _vm.handleIframeError
    }
  }) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fast-fade"
    }
  }, [_vm.sourceType === 'iframe' && _vm.isIframeLoading ? _c('div', {
    staticClass: "iframe-loader"
  }, [_c('div', {
    staticClass: "iframe-loader__spinner"
  }), _c('div', {
    staticClass: "iframe-loader__text"
  }, [_vm._v("Loading…")])]) : _vm._e()]), _vm.sourceType === 'video' ? _c('video', {
    ref: "video",
    attrs: {
      "src": _vm.activeSource,
      "autoplay": !_vm.isTransitionVideo,
      "playsinline": "",
      "disablePictureInPicture": "",
      "loop": _vm.shouldLoop,
      "poster": "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
    },
    domProps: {
      "muted": _vm.isVideoMuted
    },
    on: {
      "ended": _vm.handleVideoEnd
    }
  }) : _vm._e(), _vm.sourceType === 'video' && (_vm.backgroundVideoSettings ? _vm.backgroundVideoSettings.showControls : true) ? _c('div', {
    staticClass: "background__control",
    style: {
      bottom: _vm.controlsBottomPx,
      right: _vm.controlsRightPx
    }
  }, [_c('div', {
    staticClass: "control control--mute touch",
    on: {
      "click": _vm.toggleMute
    }
  }, [_vm.isVideoMuted ? _c('fa', {
    attrs: {
      "icon": ['fal', 'volume-mute']
    }
  }) : _vm._e(), !_vm.isVideoMuted ? _c('fa', {
    attrs: {
      "icon": ['fal', 'volume']
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "control control--playback touch",
    on: {
      "click": _vm.togglePlayback
    }
  }, [_vm.isVideoPlaying ? _c('fa', {
    attrs: {
      "icon": ['fal', 'pause']
    }
  }) : _vm._e(), !_vm.isVideoPlaying ? _c('fa', {
    attrs: {
      "icon": ['fal', 'play']
    }
  }) : _vm._e()], 1)]) : _vm._e()], 1)])], 1) : _vm._e()])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }